import { ErrorCrossIcon } from '@/shared/assets';
import {
  AnimatedWrapper,
  Button,
  Heading,
  Support,
  Typography,
} from '@/shared/ui';

interface IErrorFallbackProps {
  title?: string;
  description?: string;
  onTryAgain?: () => void;
}

const ErrorFallback = ({
  title = 'Something went wrong',
  description = 'There was a problem processing the request. Please try again',
  onTryAgain,
}: IErrorFallbackProps) => {
  const onReload = () => {
    window.location.reload();
  };

  return (
    <AnimatedWrapper isFirst={false} id="error-boundary" className="pt-0">
      <div className="top-0 z-10 flex h-screen w-full flex-col items-center justify-center bg-surface-00 text-center">
        <img
          src={ErrorCrossIcon}
          alt="Error cross icon"
          width={242}
          height={255}
        />
        <Heading className="mb-5 mt-7">{title}</Heading>
        <Typography className="mb-8 max-w-[350px] lg:max-w-full">
          {description}
        </Typography>
        <Button variant="contrast-500" onClick={onTryAgain ?? onReload}>
          Try again
        </Button>
      </div>
      <Support />
    </AnimatedWrapper>
  );
};

export default ErrorFallback;
